/**
 * load弹窗
 *  props
 *    visible bool 是否显示
 *    title String 弹窗名称
 *      btn-item Object {name:'',callBack:fun}
 */
import ReactDOM from 'react-dom';
import React from 'react';
import { ActivityIndicator } from 'antd-mobile';
import loadingHardly from './assets/loadingHardly.gif';
import autoCheck from './assets/autoCheck.gif';
import './index.less';

let popUpLoadQueue = [];

function PopUpLoadComponent({ type, onClose, lang }) {
  return (
    <div
      className="popUpLoad"
      style={
        type === 'act'
          ? { background: '#000', opacity: '.1' }
          : { background: '#f7fbff' }
      }
    >
      {type === 'act' ? (
        <div className="popUpLoad_main">
          <ActivityIndicator />
        </div>
      ) : (
        <img
          alt=""
          style={
            type === 'load'
              ? { width: '2.5rem', marginBottom: '0.15rem' }
              : { width: '2.3rem', marginBottom: '0.15rem' }
          }
          src={type === 'load' ? loadingHardly : autoCheck}
        />
      )}
      <div id="loadAria">
        {type === 'load' ? lang.automatic1 : lang.automatic2}
      </div>
    </div>
  );
}

export default function PopUpLoad(...args) {
  const type = args[0] || 'act';
  const lang = args[1] || {};

  let timeoutEvn = null;
  let div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    if (!div) return;
    clearTimeout(timeoutEvn);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  ReactDOM.render(
    <PopUpLoadComponent
      type={type}
      lang={lang}
      onClose={() => {
        close();
      }}
    />,
    div
  );

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('loadAria').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  popUpLoadQueue.push({
    close,
  });

  timeoutEvn = setTimeout(() => {
    focus();
  }, 200);
  return popUpLoadQueue[popUpLoadQueue.length - 1];
}

PopUpLoad.clear = () => {
  if (popUpLoadQueue && popUpLoadQueue.length) {
    popUpLoadQueue.forEach(progess => {
      progess.close();
    });
    popUpLoadQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/components/PopUpLoad/index.js